import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Invoice } from "@/v2/types";

export default async function FindOneInvoice(id: string): Promise<Invoice> {
    const res = await apiClientWithRefreshToken({
        url: `/invoices/${id}`,
        method: "GET",
    });
    return res.data;
}
